module.exports = require('./dist/md-expansion-panel'); 



//////////////////
// WEBPACK FOOTER
// ./~/angular-material-expansion-panel/index.js
// module id = 367
// module chunks = 1